import React, { useEffect } from 'react';
import { Survey } from 'survey-react-ui';
import { Model } from 'survey-core';
import 'survey-core/survey-core.min.css';
import './App.css';
import AdminView from './AdminView';

// Declare EmailJS global
declare global {
  interface Window {
    emailjs: any;
  }
}

const surveyJson = {
  title: "Endoscopy Training Course - Feedback Survey",
  description: "Your feedback helps us improve our training programs. Please take a few minutes to share your experience.",
  pages: [
    {
      name: "page1",
      questionTitleWidth: "140px",
      questionTitleLocation: "left",
      elements: [
        {
          type: "text",
          name: "email",
          title: "Email:",
          titleLocation: "left",
          inputType: "email",
          isRequired: true,
          placeholder: "your.email@example.com"
        },
        {
          type: "text",
          name: "full_name",
          title: "Full Name:",
          titleLocation: "left",
          isRequired: true,
          placeholder: "Dr. John Smith"
        },
        {
          type: "text",
          name: "work_profile",
          title: "Work Profile/Specialty:",
          titleLocation: "left",
          isRequired: true,
          placeholder: "Cardiologist"
        },
        {
          type: "text",
          name: "designation",
          title: "Designation:",
          titleLocation: "left",
          isRequired: true,
          placeholder: "Senior Consultant"
        },
        {
          type: "text",
          name: "institute",
          title: "Institute/Hospital:",
          titleLocation: "left",
          isRequired: true,
          placeholder: "City General Hospital"
        },
        {
          type: "text",
          name: "whatsapp_number",
          title: "WhatsApp Number:",
          titleLocation: "left",
          isRequired: true,
          placeholder: "+1234567890"
        },
        {
          type: "text",
          name: "facebook_id",
          title: "Facebook ID:",
          titleLocation: "left",
          isRequired: true,
          placeholder: "your.facebook.id"
        },
        {
          type: "text",
          name: "instagram_handle",
          title: "Instagram Handle:",
          titleLocation: "left",
          isRequired: true,
          placeholder: "@yourhandle"
        },
        {
          type: "text",
          name: "course_discovery",
          title: "How did you come to know about the Endoscopy Training Course?",
          titleLocation: "top",
          isRequired: true
        },
        {
          type: "rating",
          name: "registration_experience",
          title: "How smooth was your experience of registration and pre-event communication?",
          titleLocation: "top",
          isRequired: true,
          rateMin: 1,
          rateMax: 5,
          minRateDescription: "",
          maxRateDescription: "",
          rateType: "stars",
          displayMode: "buttons"
        },
        {
          type: "rating",
          name: "venue_rating",
          title: "Please rate the venue Excel Hospital in terms of facilities, ease of access and infrastructure.",
          titleLocation: "top",
          isRequired: true,
          rateMin: 1,
          rateMax: 5,
          minRateDescription: "",
          maxRateDescription: "",
          rateType: "stars",
          displayMode: "buttons"
        },
        {
          type: "rating",
          name: "content_rating",
          title: "Please rate our content and program schedule in terms of learning Endoscopy.",
          titleLocation: "top",
          isRequired: true,
          rateMin: 1,
          rateMax: 5,
          minRateDescription: "",
          maxRateDescription: "",
          rateType: "stars",
          displayMode: "buttons"
        },
        {
          type: "rating",
          name: "faculty_rating",
          title: "Please rate our Faculty & Speakers in terms of course content delivery.",
          titleLocation: "top",
          isRequired: true,
          rateMin: 1,
          rateMax: 5,
          minRateDescription: "",
          maxRateDescription: "",
          rateType: "stars",
          displayMode: "buttons"
        },
        {
          type: "text",
          name: "course_goal",
          title: "What was your primary goal for joining the Course?",
          titleLocation: "top",
          isRequired: true
        },
        {
          type: "rating",
          name: "goal_satisfaction",
          title: "Would you say you were satisfied with how the STEP Course met your goals/expectations?",
          titleLocation: "top",
          isRequired: true,
          rateMin: 1,
          rateMax: 5,
          minRateDescription: "",
          maxRateDescription: "",
          displayMode: "buttons",
          rateType: "smileys"
        },
        {
          type: "comment",
          name: "additional_feedback",
          title: "Please provide your feedback, extra suggestions or comments that you wish to put forward regarding the Course.",
          titleLocation: "top",
          isRequired: true,
          rows: 4
        },
        {
          type: "radiogroup",
          name: "future_interest",
          title: "Would you be interested in our upcoming event of Training in Ultrasonography of the Abdomen for Surgeons?",
          titleLocation: "top",
          isRequired: true,
          choices: [
            { value: "definitely_yes", text: "Definitely Yes" },
            { value: "no", text: "No" },
            { value: "not_sure", text: "Not Sure" }
          ]
        },
        {
          type: "comment",
          name: "future_suggestions",
          title: "Please give a list of subjects that you wish us to include in future training courses, modules, and workshops.",
          titleLocation: "top",
          isRequired: true,
          rows: 3
        },
        {
          type: "html",
          name: "footer_info",
          html: "<div style='background-color: #f8f9fa; padding: 20px; border-radius: 8px; margin-top: 30px; text-align: center; border: 1px solid #e0e0e0;'><h4 style='color: #323395; margin-bottom: 15px; font-weight: bold;'>ASI STEP COURSE AUGUST 2025 EXCEL HOSPITAL FEEDBACK FORM</h4><p style='color: #666; margin: 0; line-height: 1.5;'>Thank you for participating in the ASI STEP Course 2025 in Endoscopy at Excel Hospital, Ahmedabad. This form will help us solicit your valuable feedback, to help us pave the way forwards for future events.</p></div>"
        }
      ]
    }
  ],
  completedHtml: "<div style='text-align: center; padding: 40px 20px; background-color: #f8f9fa; border-radius: 12px; border: 2px solid #323395;'><h2 style='color: #323395; margin-bottom: 20px; font-family: \"Lora\", serif;'>Thank You for Your Valuable Feedback!</h2><p style='color: #666; font-size: 16px; line-height: 1.6; margin-bottom: 15px;'>Your responses have been successfully submitted and recorded.</p><p style='color: #323395; font-weight: 500; margin-bottom: 20px;'>We appreciate your time and input to help us improve our training programs.</p><div style='background-color: #323395; color: white; padding: 15px; border-radius: 8px; margin: 20px 0;'><strong>ASI STEP Course 2025 - Excel Hospital, Ahmedabad</strong></div><p style='color: #666; font-size: 14px;'>Your feedback will help us enhance future medical training courses and workshops.</p></div>",
  showQuestionNumbers: "off",
  completeText: "Submit"
};

function App() {
  // Initialize EmailJS when component mounts
  useEffect(() => {
    if (window.emailjs) {
      window.emailjs.init("jmoXjl-uzNnedbeXa"); // Your public key
      console.log('EmailJS initialized successfully');
    } else {
      console.error('EmailJS library not loaded');
    }
  }, []);

  // Temporarily disable admin view due to CORS issues
  // const isAdminView = window.location.hash === '#admin';
  // if (isAdminView) {
  //   return <AdminView />;
  // }

  const survey = new Model(surveyJson);

  // Apply Excel Hospital theme with doubleborder for prominent borders
  survey.applyTheme({
    "themeName": "doubleborder",
    "colorPalette": "light",
    "isPanelless": true,
    "backgroundImage": "",
    "backgroundImageFit": "cover",
    "backgroundImageAttachment": "scroll",
    "backgroundOpacity": 1,
    "cssVariables": {
        "--sjs-font-family": "'Roboto', sans-serif",
        "--sjs-font-size": "16px",
        "--sjs-corner-radius": "4px",
        "--sjs-base-unit": "8px",
        "--sjs-shadow-small": "0px 0px 0px 2px rgba(0, 0, 0, 0.07)",
        "--sjs-shadow-inner": "0px 0px 0px 2px rgba(0, 0, 0, 0.1)",
        "--sjs-border-default": "rgba(0, 0, 0, 0.1)",
        "--sjs-border-light": "rgba(0, 0, 0, 0.1)",
        "--sjs-general-backcolor": "rgba(255, 255, 255, 1)",
        "--sjs-general-backcolor-dark": "rgba(243, 243, 243, 1)",
        "--sjs-general-backcolor-dim-light": "rgba(245, 245, 245, 1)",
        "--sjs-general-backcolor-dim-dark": "rgba(234, 234, 234, 1)",
        "--sjs-general-forecolor": "rgba(0, 0, 0, 0.91)",
        "--sjs-general-forecolor-light": "rgba(0, 0, 0, 0.43)",
        "--sjs-general-dim-forecolor": "#ffffff",
        "--sjs-general-dim-forecolor-light": "#ffffff",
        "--sjs-secondary-backcolor": "#E42223",
        "--sjs-secondary-backcolor-light": "rgba(228, 34, 35, 0.1)",
        "--sjs-secondary-backcolor-semi-light": "rgba(228, 34, 35, 0.25)",
        "--sjs-secondary-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-secondary-forecolor-light": "rgba(255, 255, 255, 0.25)",
        "--sjs-shadow-small-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0.07)",
        "--sjs-shadow-medium": "0px 0px 0px 2px rgba(0, 0, 0, 0.08),0px 2px 6px 0px rgba(0, 0, 0, 0.04)",
        "--sjs-shadow-large": "0px 8px 16px 0px rgba(0, 0, 0, 0.08)",
        "--sjs-shadow-inner-reset": "0px 0px 0px 0px rgba(0, 0, 0, 0.1)",
        "--sjs-border-inside": "rgba(0, 0, 0, 0.16)",
        "--sjs-special-red-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-special-green": "rgba(25, 179, 148, 1)",
        "--sjs-special-green-light": "rgba(25, 179, 148, 0.1)",
        "--sjs-special-green-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-special-blue": "#323395",
        "--sjs-special-blue-light": "rgba(50, 51, 149, 0.1)",
        "--sjs-special-blue-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-special-yellow": "rgba(255, 152, 20, 1)",
        "--sjs-special-yellow-light": "rgba(255, 152, 20, 0.1)",
        "--sjs-special-yellow-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-primary-backcolor": "#323395",
        "--sjs-primary-backcolor-dark": "rgba(40, 42, 128, 1)",
        "--sjs-primary-backcolor-light": "rgba(50, 51, 149, 0.1)",
        "--sjs-primary-forecolor": "rgba(255, 255, 255, 1)",
        "--sjs-primary-forecolor-light": "rgba(255, 255, 255, 0.25)",
        "--sjs-special-red": "#E42223",
        "--sjs-special-red-light": "rgba(228, 34, 35, 0.1)",
        "--sjs-header-backcolor": "#ffffff",
        "--sjs-header-forecolor": "#323395"
    },
    "header": {
        "height": 0,
        "mobileHeight": 0,
        "inheritWidthFrom": "survey",
        "textAreaWidth": 0,
        "backgroundImageFit": "cover",
        "backgroundImageOpacity": 100,
        "overlapEnabled": false,
        "logoPositionX": "left",
        "logoPositionY": "top",
        "titlePositionX": "left",
        "titlePositionY": "bottom",
        "descriptionPositionX": "left",
        "descriptionPositionY": "bottom"
    },
    "headerView": "basic"
  });

  // Set global question title location to top (default)
  survey.questionTitleLocation = "top";
  
  // Center align questions
  survey.questionTitlePattern = "numTitleRequire";

  const onSurveyComplete = async (sender: Model) => {
    const timestamp = new Date().toISOString();
    const submissionId = `submission_${Date.now()}`;
    
    console.log(`[${timestamp}] Survey completed - ID: ${submissionId}`);
    console.log(`[${timestamp}] Survey data:`, {
      submissionId,
      questionsAnswered: Object.keys(sender.data).length,
      data: sender.data
    });
    
    // Send email via EmailJS
    try {
      if (window.emailjs) {
        console.log(`[${timestamp}] Sending survey via EmailJS...`);
        
        // Helper function to convert future_interest value to display text
        const getFutureInterestText = (value: string) => {
          switch(value) {
            case 'definitely_yes': return 'Definitely Yes';
            case 'no': return 'No';
            case 'not_sure': return 'Not Sure';
            default: return value || 'Not provided';
          }
        };
        
        // Prepare email template parameters
        const templateParams = {
          // Recipient info
          to_email: "contact.excelhospital@gmail.com", // Updated as per issue #1
          reply_to: sender.data.email || "no-reply@excelhospital.com",
          
          // Submission metadata
          submission_id: submissionId,
          submission_date: new Date().toLocaleString(),
          
          // Personal Information
          from_name: sender.data.full_name || "Not provided",
          from_email: sender.data.email || "Not provided",
          work_profile: sender.data.work_profile || "Not provided",
          designation: sender.data.designation || "Not provided",
          institute: sender.data.institute || "Not provided",
          whatsapp_number: sender.data.whatsapp_number || "Not provided",
          facebook_id: sender.data.facebook_id || "Not provided",
          instagram_handle: sender.data.instagram_handle || "Not provided",
          
          // Course Discovery
          course_discovery: sender.data.course_discovery || "Not provided",
          
          // Ratings (convert to stars for email display)
          registration_experience: `${sender.data.registration_experience || 0}/5 stars`,
          venue_rating: `${sender.data.venue_rating || 0}/5 stars`,
          content_rating: `${sender.data.content_rating || 0}/5 stars`,
          faculty_rating: `${sender.data.faculty_rating || 0}/5 stars`,
          goal_satisfaction: `${sender.data.goal_satisfaction || 0}/5`,
          
          // Text Feedback
          course_goal: sender.data.course_goal || "Not provided",
          additional_feedback: sender.data.additional_feedback || "Not provided",
          future_interest: getFutureInterestText(sender.data.future_interest),
          future_suggestions: sender.data.future_suggestions || "Not provided",
          
          // Email metadata
          subject: "New Response: ASI STEP Course - August 2025",
          email_title: "ASI STEP Course August 2025 - Excel Hospital Feedback",
        };
        
        // Send email using EmailJS
        // IMPORTANT: Replace 'YOUR_SERVICE_ID' with your actual EmailJS service ID
        const SERVICE_ID = "service_l1opx5b"; // TODO: Replace with YOUR service ID from EmailJS dashboard
        const TEMPLATE_ID = "template_c4fyikm"; // Your template ID
        
        await window.emailjs.send(
          SERVICE_ID,
          TEMPLATE_ID,
          templateParams
        );
        
        console.log(`[${timestamp}] ✅ Email sent successfully via EmailJS`);
      }
    } catch (emailError) {
      console.error(`[${timestamp}] ⚠️ Error sending email:`, emailError);
      // Don't fail the entire submission if email fails
    }
    
    try {
      // Use API endpoint for production, direct Appwrite for local development
      const isProduction = window.location.hostname !== 'localhost';
      
      if (isProduction) {
        // Production: Use API endpoint to avoid CORS issues
        console.log(`[${timestamp}] Sending survey to backend API...`);
        const response = await fetch('/api/submit-survey', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            ...sender.data,
            submissionId,
            clientTimestamp: timestamp
          })
        });

        if (response.ok) {
          const result = await response.json();
          console.log(`[${timestamp}] ✅ Survey submitted successfully:`, {
            submissionId,
            appwriteId: result.submissionId,
            message: result.message
          });
          alert('Survey submitted successfully! Thank you for your feedback.');
          return;
        } else {
          throw new Error(`API error: ${response.status} ${response.statusText}`);
        }
      }
      
      // Local development: Direct Appwrite integration
      const { Client, Databases, ID } = await import('appwrite');
      
      const client = new Client();
      client
        .setEndpoint('https://cloud.appwrite.io/v1')
        .setProject('68a991c1000e07b6b06c');

      const databases = new Databases(client);
      
      // Prepare document for Appwrite
      const document = {
        client_submission_id: submissionId,
        client_timestamp: timestamp,
        server_timestamp: timestamp,
        email: sender.data.email || '',
        full_name: sender.data.full_name || '',
        work_profile: sender.data.work_profile || '',
        designation: sender.data.designation || '',
        institute: sender.data.institute || '',
        whatsapp_number: sender.data.whatsapp_number || '',
        facebook_id: sender.data.facebook_id || '',
        instagram_handle: sender.data.instagram_handle || '',
        course_discovery: sender.data.course_discovery || '',
        registration_experience: parseInt(sender.data.registration_experience) || 0,
        venue_rating: parseInt(sender.data.venue_rating) || 0,
        content_rating: parseInt(sender.data.content_rating) || 0,
        faculty_rating: parseInt(sender.data.faculty_rating) || 0,
        course_goal: sender.data.course_goal || '',
        goal_satisfaction: parseInt(sender.data.goal_satisfaction) || 0,
        additional_feedback: sender.data.additional_feedback || '',
        future_interest: sender.data.future_interest || '',
        future_suggestions: sender.data.future_suggestions || '',
        submitted_at: timestamp
      };

      console.log(`[${timestamp}] Saving to Appwrite SurveyResponses collection...`);
      
      // Save to Appwrite database (using old working collection)
      const result = await databases.createDocument(
        '68a99a0f0005d7b1d94e', // Database ID
        '68a99a450019d1118e77', // Collection ID - old SurveyResponses that worked
        ID.unique(),             // Document ID
        document
      );

      console.log(`[${timestamp}] ✅ Survey saved successfully:`, {
        appwriteId: result.$id,
        clientSubmissionId: submissionId,
        createdAt: result.$createdAt
      });
      
      alert('Survey submitted successfully! Thank you for your feedback.');
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Unknown error';
      const errorStack = error instanceof Error ? error.stack : undefined;
      
      console.error(`[${timestamp}] 🔥 Error saving survey to Appwrite:`, {
        error: errorMessage,
        stack: errorStack
      });
      alert('There was an issue submitting your survey. Please try again.');
    }
  };

  survey.onComplete.add(onSurveyComplete);

  return (
    <div className="App">
      <header style={{ textAlign: 'center', marginBottom: '30px', padding: '20px' }}>
        <img 
          src="/excel-hospital.png" 
          alt="Excel Hospital Logo" 
          style={{ maxHeight: '80px', marginBottom: '20px' }}
        />
      </header>
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '0 20px 20px' }}>
        <Survey model={survey} />
      </div>
    </div>
  );
}

export default App;
